import { useEffect } from 'react';

function setMetaAttribute(selector, attribute, value) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    const nameMatch = selector.match(/\[name="([^"]+)"\]/);
    const propertyMatch = selector.match(/\[property="([^"]+)"\]/);

    if (nameMatch) {
      element.setAttribute('name', nameMatch[1]);
    }

    if (propertyMatch) {
      element.setAttribute('property', propertyMatch[1]);
    }

    document.head.appendChild(element);
  }

  element.setAttribute(attribute, value);
}

function setCanonical(path) {
  const canonicalUrl = `${window.location.origin}${path}`;
  let canonical = document.head.querySelector('link[rel="canonical"]');

  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }

  canonical.setAttribute('href', canonicalUrl);
  setMetaAttribute('meta[property="og:url"]', 'content', canonicalUrl);
}

function Seo({ title, description, path = '/' }) {
  useEffect(() => {
    document.title = title;
    setMetaAttribute('meta[name="description"]', 'content', description);
    setMetaAttribute('meta[property="og:title"]', 'content', title);
    setMetaAttribute('meta[property="og:description"]', 'content', description);
    setMetaAttribute('meta[name="twitter:title"]', 'content', title);
    setMetaAttribute('meta[name="twitter:description"]', 'content', description);
    setCanonical(path);
  }, [title, description, path]);

  return null;
}

export default Seo;
